import matrix9BoxApi from '@/api/matrix-9-box';
import {mutationTypes} from '@/store/modules/matrix-9-box/mutations';

export const actionsTypes = {
  getMatrices: '[matrix-9-box] get matrices',
  getMatrixDetails: '[matrix-9-box] get matrix details',
  getCalibrationHistory: '[matrix-9-box] get calibration history',

  checkCreationMatrix: '[matrix-9-box] check creation matrix',
  createMatrix: '[matrix-9-box] create matrix',
  calibrateMatrix: '[matrix-9-box] calibrate matrix',
  deleteMatrix: '[matrix-9-box] delete matrix',
  changeStateMatrix: '[matrix-9-box] change state matrix',

  exportMatrix: '[matrix-9-box] export matrix',
  exportMatrixDetails: '[matrix-9-box] export matrix details',
  importMatrix: '[matrix-9-box] import matrix',

  setDeletedEmployees: '[matrix-9-box] set deleted employees',
  addCalibrationEmployees: '[matrix-9-box] add calibration employees',
  deleteCalibrationEmployees: '[matrix-9-box] delete calibration employees',
};

const actions = {
  [actionsTypes.getMatrices](
    context,
    {
      companyId,
      filters = {},
      pagination: {limit = 10, offset = 0},
      sort: {sortField = 'date', sortOrder = 'desc'},
    }
  ) {
    const loaderObj = ['getMatrices'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      const args = {};

      if (filters && filters.name && (filters.name.length === 0 || filters.name.length > 2)) {
        args.name = filters.name;
      }

      if (filters && filters.teamIds && filters.teamIds.length > 0) {
        args.team_ids = filters.teamIds.join(',');
      }

      if (filters && filters.specCodes && filters.specCodes.length > 0) {
        args.spec_codes = filters.specCodes.join(',');
      }

      if (
        filters &&
        filters.authorName &&
        (filters.authorName.length === 0 || filters.authorName.length > 2)
      ) {
        args.author_name = filters.authorName;
      }

      if (filters && filters.period) {
        args.start_date = filters.period.start_date;
        args.end_date = filters.period.end_date;
      }

      if (filters && filters.employeeName) {
        args.employee_name = filters.employeeName;
      }

      if (filters && filters.status) {
        args.state = filters.status;
      }

      if (filters && typeof filters.calibration === 'boolean') {
        args.is_calibrated = filters.calibration;
      }

      if (limit) args.limit = limit;
      if (typeof offset === 'number') args.offset = offset;
      if (sortField) args.sort_field = sortField;
      if (sortOrder) args.sort_order = sortOrder;

      matrix9BoxApi
        .getMatrices(companyId, args)
        .then((response) => {
          context.commit(mutationTypes.getMatrices, response.data);
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.getMatrixDetails](context, matrixId) {
    const loaderObj = ['getMatrixDetails'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      matrix9BoxApi
        .getMatrixDetails(matrixId)
        .then((response) => {
          context.commit(mutationTypes.getMatrixDetails, response.data);
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.getCalibrationHistory](context, {matrixId, dataId}) {
    const loaderObj = ['getCalibrationHistory'];

    context.commit(mutationTypes.clearCalibrationHistory);
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      matrix9BoxApi
        .getCalibrationHistory(matrixId, dataId)
        .then((response) => {
          context.commit(mutationTypes.getCalibrationHistory, response.data);
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.checkCreationMatrix](context, data) {
    const loaderObj = ['checkCreationMatrix'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      matrix9BoxApi
        .checkCreationMatrix(data)
        .then((response) => {
          context.commit(mutationTypes.checkCreationMatrix, response.data);
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.createMatrix](context, data) {
    const loaderObj = ['createMatrix'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      matrix9BoxApi
        .createMatrix(data)
        .then((response) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.calibrateMatrix](context, {matrixId, data}) {
    const loaderObj = ['calibrateMatrix'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      matrix9BoxApi
        .calibrateMatrix(matrixId, data)
        .then((response) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.deleteMatrix](context, matrixId) {
    const loaderObj = ['deleteMatrix'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      matrix9BoxApi
        .deleteMatrix(matrixId)
        .then((response) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.changeStateMatrix](context, {matrixId, state}) {
    const loaderObj = ['changeStateMatrix'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      matrix9BoxApi
        .changeStateMatrix(matrixId, state)
        .then((response) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.exportMatrix](
    context,
    {
      matrixId,
      deleted = undefined, // true - исключённые сотрудники
      filters = {},
    }
  ) {
    const loaderObj = ['exportMatrix'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      const args = {};

      if (filters && filters.teamIds && filters.teamIds.length > 0) {
        args.team_ids = filters.teamIds.join(',');
      }

      if (filters && filters.specCodes && filters.specCodes.length > 0) {
        args.spec_codes = filters.specCodes.join(',');
      }

      if (filters && filters.userIds && filters.userIds.length > 0) {
        args.user_ids = filters.userIds.join(',');
      }

      if (filters && filters.competence && filters.competence.length > 0) {
        args.tests_rank = filters.competence.join(',');
      }

      if (filters && filters.efficiency && filters.efficiency.length > 0) {
        args.targets_rank = filters.efficiency.join(',');
      }

      if (filters && typeof filters.fullData === 'boolean') {
        args.is_full = filters.fullData ? 'full' : 'empty';
      }

      if (typeof deleted === 'boolean') {
        args.deleted = deleted ? 'deleted' : 'enabled';
      }

      matrix9BoxApi
        .exportMatrix(matrixId, args)
        .then((response) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.exportMatrixDetails](context, {matrixId, filters = {}}) {
    const loaderObj = ['exportMatrixDetails'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      const args = {};

      if (filters && filters.teamIds && filters.teamIds.length > 0) {
        args.team_ids = filters.teamIds.join(',');
      }

      if (filters && filters.specCodes && filters.specCodes.length > 0) {
        args.spec_codes = filters.specCodes.join(',');
      }

      if (filters && filters.userIds && filters.userIds.length > 0) {
        args.user_ids = filters.userIds.join(',');
      }

      if (filters && filters.areaCode) {
        args.zone_code = filters.areaCode;
      }

      if (filters && typeof filters.calibration === 'boolean') {
        args.is_calibrated = filters.calibration;
      }

      matrix9BoxApi
        .exportMatrixDetails(matrixId, args)
        .then((response) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.importMatrix](context, {matrixId, data}) {
    const loaderObj = ['importMatrix'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      matrix9BoxApi
        .importMatrix(matrixId, data)
        .then((response) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.setDeletedEmployees](context, {matrixId, data}) {
    const loaderObj = ['setDeletedEmployees'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      matrix9BoxApi
        .setDeletedEmployees(matrixId, data)
        .then((response) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.addCalibrationEmployees](context, {matrixId, data}) {
    const loaderObj = ['addCalibrationEmployees'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      matrix9BoxApi
        .addCalibrationEmployees(matrixId, data)
        .then((response) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },

  [actionsTypes.deleteCalibrationEmployees](context, {matrixId, data}) {
    const loaderObj = ['deleteCalibrationEmployees'];
    context.commit(mutationTypes.setLoadingObject, {loaderObj, data: true});

    return new Promise((resolve, reject) => {
      matrix9BoxApi
        .deleteCalibrationEmployees(matrixId, data)
        .then((response) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.setLoadingObject, {loaderObj, data: false});
          reject(result);
        });
    });
  },
};

export default actions;
